import { render, staticRenderFns } from "./WPClusterAdd.vue?vue&type=template&id=0edf9c9b&scoped=true&"
import script from "./WPClusterAdd.vue?vue&type=script&lang=js&"
export * from "./WPClusterAdd.vue?vue&type=script&lang=js&"
import style0 from "./WPClusterAdd.vue?vue&type=style&index=0&id=0edf9c9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf9c9b",
  null
  
)

export default component.exports